import { useTranslation } from 'react-i18next';
import { mockMessages } from '@/mocks/dashboard';
import DashboardMessages from './components/DashboardMessages';

export default function MessagesPage() {
  const { t } = useTranslation('dashboard');
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-xl md:text-2xl font-bold text-ink-700">{t('dashboard.messages.title')}</h1>
        <p className="text-sm text-ink-300 mt-1">Notifications and updates</p>
      </div>
      <DashboardMessages messages={mockMessages} />
    </div>
  );
}